"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _reactRedux = require("react-redux");

var _login = _interopRequireDefault(require("../../../../login"));

var _dialog = _interopRequireDefault(require("../../../../_common/dialog"));

var _selectors = require("../../../../../redux/login/selectors");

var _actions = require("../../../../../redux/locations/actions");

var _fullScreen = _interopRequireDefault(require("../../../../_common/dialog/fullScreen"));

var _nicaLocatorCore = require("../../../../nicaLocatorCore");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ClaimDialog = function ClaimDialog(_ref) {
  var open = _ref.open,
      onClose = _ref.onClose,
      location = _ref.location;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showLogin = _useState2[0],
      setShowLogin = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showConfirmation = _useState4[0],
      setShowConfirmation = _useState4[1];

  var _useLoginSelector = (0, _selectors.useLoginSelector)(),
      user = _useLoginSelector.claims;

  var dispatch = (0, _reactRedux.useDispatch)();

  var _useContext = (0, _react.useContext)(_nicaLocatorCore.AppContext),
      adminUrl = _useContext.strings.adminUrl;

  var title = "Are you associated with ".concat(location && location.name, "?");
  var content = "If so, Login and then Claim this location to edit the data displayed!";

  var actions = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "text",
    color: "default",
    onClick: onClose
  }, "Cancel"), /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "contained",
    color: "secondary",
    onClick: function onClick() {
      return setShowLogin(true);
    }
  }, "Login"));

  if (user.user_id) {
    title = "Claim ".concat(location && location.name);
    content = "By hitting Submit, you are claiming ownership/administration of this Infusion Center Location.\n\nThis location will be temporarily hidden from the public until a NICA team member can verify your identity.";
    actions = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
      variant: "text",
      color: "default",
      onClick: onClose
    }, "Cancel"), /*#__PURE__*/_react.default.createElement(_Button.default, {
      variant: "contained",
      color: "secondary",
      onClick: function onClick() {
        dispatch((0, _actions.claimLocation)(user, location.id, location.name));
        setShowConfirmation(true);
      }
    }, "Submit"));

    if (showConfirmation) {
      title = "Claim ".concat(location && location.name);
      content = "Thank you for claiming this location.\n\nYou may now edit the data for this location in the Location Manager but it will not be publicly visible until a NICA team member validates your information.";
      actions = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
        variant: "text",
        color: "default",
        onClick: onClose
      }, "Done"), /*#__PURE__*/_react.default.createElement(_Button.default, {
        variant: "contained",
        color: "secondary",
        onClick: function onClick() {
          return window.open("".concat(adminUrl || "https://admin.infusioncenter.org/locations", "/").concat(location && location.id));
        }
      }, "Go To Location Manager"));
    }
  }

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_dialog.default, {
    open: open,
    onClose: onClose,
    title: title,
    actions: actions
  }, content), /*#__PURE__*/_react.default.createElement(_fullScreen.default, {
    onClose: function onClose() {
      return setShowLogin(false);
    },
    open: showLogin
  }, /*#__PURE__*/_react.default.createElement(_login.default, {
    onClose: function onClose() {
      return setShowLogin(false);
    }
  })));
};

var _default = ClaimDialog;
exports.default = _default;